<template>
		<!-- Muzee -->
		<div class="container mx-auto mt-8">
		<ListaMuzee :museums="museums" :stateFilter="false" :searchFilter="true" :pageTitle="pageTitle"/>
		</div>

		<!-- Load more projects button -->
		<!-- <div class="mt-10 sm:mt-20 flex justify-center">
			<router-link
				to="/projects"
				class="font-general-medium flex items-center px-6 py-3 rounded-lg shadow-lg hover:shadow-xl bg-indigo-500 hover:bg-indigo-600 focus:ring-1 focus:ring-indigo-900 text-white text-lg sm:text-xl duration-300"
				aria-label="More Projects"
			>
				<Button title="More Projects" />
			</router-link>
		</div> -->
</template>


<script>
import ListaMuzee from '../components/ListaMuzee.vue';
import { mapGetters } from 'vuex'

export default {
	name: 'MuseumList',
    data(){
        return {
            museums: null,
			page: null,
			pageTitle: null
        }
    },
	components: {
		ListaMuzee
	},
	async created() {
		await this.$store.dispatch('fetchMuseums');
		await this.$store.dispatch('fetchPages');
		this.page = this.$store.getters.getPageByLink(this.$route.params.slug);
		this.pageTitle = this.page.title;
		if (this.page != null) {
			this.museums = this.$store.getters.getMuseumsForPage(this.$route.params.slug);
		}
	},
	computed: {
		...mapGetters([
		'getMuseumsForPage'
		])
	}
};
</script>



<style scoped></style>
